import { Gewerk } from '@myapp/contract'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { gewerkKeys } from '../keys'
import { gewerkApi } from '../service'

export const useGewerkDetail = (
  gewerkId: number | undefined,
  options?: Omit<UseQueryOptions<Gewerk>, 'queryKey' | 'queryFn'>,
) =>
  useQuery({
    queryKey: gewerkKeys.detail(gewerkId as number),
    queryFn: async () => {
      const { data } = await gewerkApi.getById(gewerkId as number)
      return data
    },
    enabled: !!gewerkId && (options?.enabled ?? true),
    ...options,
  })
